import React, { Component } from "react";
import { StyleRoot } from "radium";
import { styles } from "../../../../../ReactConst";
import Close from "../../../../../Icons/Close";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import ReactCrop from "react-image-crop";
import { withTranslation } from 'react-i18next';

const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

class UploadMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: false,
      src: null,
      croppedImageUrl: null,
      crop: {
        unit: "%",
        width: 30,
      },
    };
    this.onCloseUploadMobile = this.onCloseUploadMobile.bind(this);
    this.uploadPhotoMobile = this.uploadPhotoMobile.bind(this);
  }
  onImageLoaded = (image) => {
    this.imageRef = image;
  };
  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.props.getCroppedImage(croppedImageUrl);

      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(blob);
      }, "image/jpeg");
    });
  }

  onCloseUploadMobile() {
    this.props.onCloseUploadMobile();

    setTimeout(() => {
      this.setState({
        styleFadeIn: false,
      });
    }, 400);
  }
  uploadPhotoMobile(e) {
    e.preventDefault();
    this.props.uploadPhotoMobile(e);

    setTimeout(() => {
      this.setState({
        styleFadeIn: false,
      });
    }, 400);
  }

  render() {
    const { crop, croppedImageUrl } = this.state;

    return (
      <StyleRoot>
        <div
          className="modal show modal-skin"
          id="modalAddMedia"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modalMedia"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content" style={{ top: 140 }}>
              <form onSubmit={this.handleSubmit}>
                <button
                  type="button"
                  onClick={this.onCloseUploadMobile}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close src="img/close.svg" className="img-fluid" alt="" />
                </button>
                <div className="modal-body" style={{ paddingBottom: 0 }}>
                  <h5 className="modal-title mt-0">{this.props.t('fiche_enfant.photo.resize')}</h5>

                  <ReactCrop
                    src={this.props.photo}
                    crop={crop}
                    ruleOfThirds
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                  />
                </div>
                <div class="d-flex justify-content-center ">
                  <button
                    type="submit"
                    className=" btn-gradient btn-valid "
                    style={{ marginBottom: "5px" }}
                    onClick={(e) => this.uploadPhotoMobile(e)}
                  >
                    <IconValider />
                    {this.props.t('common.validate')}{" "}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
export default withTranslation()(UploadMobile);
